import styled from 'styled-components';

export const ServiceGroupDescription = styled.div`
  color: #545454;
  font-size: 14px;
  white-space: pre-wrap;
`;
